const loadData = function (url, cb) {
    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        xhrFields: {
            withCredentials: true
        },
        success: cb
    });
}

module.exports = (function ($) {
    $.fn.selectize = function () {
        const selectize = {
            util: {},
            dropdown: {}
        };
        let $openedList = null;
        let counter = 0;

        selectize.util.findParentOverflowHidden = function ($el) {
            let $parent = null;

            $el.parents().each(function () {
                if ($(this).css('overflow') == 'hidden') {
                    $parent = $(this);
                    return false;
                }
            });

            return $parent;
        };

        selectize.util.generateCustomList = function ($select, $list) {
            let htmlFragment = [], $options;

            $options = $select.children('option');

            if ($options.length) {

                $list.empty();

                $options.each(function (index) {
                    let htmlFragment = '';

                    //if ( index > 0 || $(this).attr('value') ) {
                    const label = $(this).text().trim();

                    if (label) {
                        if ($(this).val() == '__placeholder__') {
                            $select.placeholder = label;
                        } else {
                            htmlFragment = `
                            <li class="selectize__list__item">
                                <span>
                                    ${label}
                                </span>
                            </li>`;

                            htmlFragment = $(htmlFragment);
                            htmlFragment.label = label;
                            htmlFragment.data('option', $(this)).appendTo($list);
                        }
                    }
                });

                $list.find('li:last').addClass('last');
            }
        };

        selectize.util.setValue = function ($select, $value) {
            let $selected = $select.children(':selected');
            let isSelected = false;
            let value = '';

            if ($selected.length) {
                value = $selected.text().trim();
                $select.selectedValue = value;
                isSelected = true;
            }

            if (isSelected && $selected.val() == '__placeholder__') {
                $select.placeholder = value;
                $value.attr('placeholder', $select.placeholder);

                value = '';
                $select.selectedValue = '';
                isSelected = false;
            }

            $value.val(value);
            $value.closest('.selectize')[isSelected ? 'addClass' : 'removeClass']('_selected');
        };

        return this.each(function () {
            var $select = $(this), selectizeOpts = null;

            if ($select.data('selectize_is_init') === true) {
                return;
            }

            $select.selectedValue = '';
            $select.placeholder = '';

            var $html = $(`
                <div class="selectize">
                    <div class="selectize__value">
                        <input type="text" value="">
                        <svg class="selectize__bullet-top">
                            <use xlink:href="#select_arrow" x="0" y="0" />
                        </svg>
                        <svg class="selectize__bullet-bottom">
                            <use xlink:href="#select_arrow" x="0" y="0" />
                        </svg>
                    </div>
                    <div class="selectize__dropdown">
                        <div class="selectize__dropdown-wrapper">
                            <ul class="selectize__list"></ul>
                        </div>
                    </div>
                </div>
            `);

            //const $bgbody = $html.find('.uis-body');
            const $dropdown = $html.find('.selectize__dropdown');
            const $dropdownWrapper = $html.find('.selectize__dropdown-wrapper');
            const $list = $html.find('.selectize__list');
            const $valueBtn = $html.find('.selectize__value');
            const $value = $valueBtn.children('input');
            const $bar = $html.find('.uis-bar');
            const $slider = $bar.find('.uis-slider');

            let isScrolling = false;
            let info = {};
            let isOpen = false;
            let maxHeight = parseInt($select.attr('data-max-height')) || 300;
            let selectedIndex = null;
            let previousSelectedIndex = null;

            if ($select.data('theme')) {
                $html.addClass(`selectize-${$select.data('theme')}`);
            }

            const dropdownDetectTopPos = function () {
                var posTop, listH, parentH, widgetH, listOffset, parentOffset, $parent;

                posTop = 0;
                $parent = selectize.util.findParentOverflowHidden($html);

                if ($parent) {
                    parentH = $parent.innerHeight();
                    listH = $dropdown.innerHeight();
                    widgetH = $html.innerHeight();

                    parentOffset = $parent.offset();
                    listOffset = $dropdown.offset();

                    if ((parentH + parentOffset.top) < (listH + listOffset.top)) {
                        if (parentOffset.top < (listOffset.top - listH - widgetH)) {
                            posTop = (listH - widgetH) * -1;
                        }
                    }
                }

                $dropdown.css({top: $html.height()});
            };

            const recalcWrapper = function () {
                info.scrollHeight = $list.get(0).scrollHeight;
                info.viewPortHeight = $list.height();
                info.scrollDiff = info.scrollHeight - info.viewPortHeight;
                info.scrollBarHeight = $bar.height();
                info.sliderHeight = $slider.height() + 2;
                info.scrollBarDiff = info.scrollBarHeight - info.sliderHeight;
                $slider.css('top', 0);
                info.sliderTop = 0;
                $list.get(0).scrollTop = 0; // refresh for FF
                if (info.scrollDiff < 1) {
                    $html.addClass('_nobar');
                    $dropdown.height(Math.min($list.height(), maxHeight));
                } else {
                    $html.removeClass('_nobar');
                }

                if (maxHeight > 0 && $list.height() > maxHeight) {
                    $dropdownWrapper.css({'overflow-y': 'scroll', height: maxHeight});
                } else {
                    $dropdownWrapper.css({'overflow-y': 'hidden', height: $list.height()});
                }

                dropdownDetectTopPos();
            }

            const openList = function () {
                $html.addClass('_opened');

                setTimeout(function () {
                    $(document.body).on('click.selectize', closeList);
                }, 50);

                if ($list.height() === 0) {
                    return;
                }

                recalcWrapper()

                if (!isOpen) {
                    isOpen = true;
                }

                $value.prop('disabled', false);
                if (!$select.selectedValue) {
                    $value.attr('placeholder', '');
                }
                $value.focus();

                $openedList = $dropdown;
            };

            const closeList = function () {
                if (isScrolling) return;
                if ($value.is(':focus')) return;

                $html.removeClass('_opened');

                if (!$select.selectedValue) {
                    $value.attr('placeholder', $select.placeholder);
                }
                $value.val($select.selectedValue);

                $value.prop('disabled', true);

                $dropdown.css({top: 0});
                if (info.scrollDiff < 1) {
                    $dropdown.height(0);
                    //$bgbody.height(25);
                }
                isOpen = false;
                $(document.body).off('click.selectize');

                clearFilterList();
            };

            selectizeOpts = $select.data('selectize');

            if (selectizeOpts && Object.prototype.toString.call(selectizeOpts) == '[object Object]' &&
                selectizeOpts.hasOwnProperty('selectWidth')) {
                $html.css('width', selectizeOpts.selectWidth);
            }

            // create list
            const dataUrl = $select.data('url');
            if (dataUrl) {
                loadData(dataUrl, function (response) {
                    var htmlFragment = [], i, len;

                    if (response && response.data !== undefined) {
                        for (key in response.data) {
                            htmlFragment.push('<option');
                            htmlFragment.push(' value="');
                            htmlFragment.push(key);
                            htmlFragment.push('">');
                            htmlFragment.push(response.data[key]);
                            htmlFragment.push('</option>');
                        }

                        $select.append(htmlFragment.join(''));
                        selectize.util.generateCustomList($select, $list);
                        selectize.util.setValue($select, $value);
                    }
                });
            } else {
                selectize.util.generateCustomList($select, $list);
                selectize.util.setValue($select, $value);
            }

            const filterList = function (value) {
                $list.children().each(function () {
                    if ($(this).text().trim().toLowerCase().indexOf(value.toLowerCase()) === -1) {
                        $(this).hide();
                    } else {
                        $(this).show();
                    }
                });
                recalcWrapper();
            }

            const clearFilterList = function (recalc = false) {
                $list.children().each(function () {
                    $(this).show();
                });
                if (recalc) {
                    recalcWrapper();
                }
            }

            const listUpDown = function (up = false) {
                let previousIndex = null;
                let isNextIndex = false;

                $list.children().each(function (index) {
                    if (up === null) {
                        selectedIndex = null;
                        return false;
                    } else {
                        if ($(this).is(":visible")) {
                            if (isNextIndex) {
                                isNextIndex = false;
                                selectedIndex = index;
                                return false;
                            }
                            if (up && selectedIndex === index) {
                                selectedIndex = previousIndex;
                                return false;
                            }
                            if (!up && selectedIndex === null) {
                                selectedIndex = index;
                                return false;
                            }
                            if (!up && selectedIndex === index) {
                                isNextIndex = true;
                            }
                            previousIndex = index;
                        }
                    }
                });

                clearListSelect()

                if (selectedIndex !== null) {
                    $($list.children()[selectedIndex]).addClass('_selected');
                    $dropdownWrapper.scrollTop($dropdownWrapper.scrollTop() + $($list.children()[selectedIndex]).position().top
                        - $dropdownWrapper.height()/2 + $($list.children()[selectedIndex]).height()/2);
                }

                previousSelectedIndex = selectedIndex;

                // console.log(selectedIndex);
                //
                //
                // $list.children().each(function (index) {
                //     if (selectedIndex === null) {
                //         $(this).removeClass('_selected');
                //     } else {
                //         if (selectedIndex === index) {
                //             $(this).addClass('_selected');
                //             $dropdownWrapper.scrollTop($dropdownWrapper.scrollTop() + $(this).position().top
                //                 - $dropdownWrapper.height()/2 + $(this).height()/2);
                //             console.log(selectedIndex);
                //         } else {
                //             $(this).removeClass('_selected');
                //         }
                //     }
                // });
            }

            const clearListSelect = function () {
                if (previousSelectedIndex !== null) {
                    $($list.children()[previousSelectedIndex]).removeClass('_selected');
                }
            }

            const listSelect = function () {
                if (selectedIndex !== null) {
                    listItemClick($($list.children()[selectedIndex]).data('option'))

                    clearListSelect();
                    previousSelectedIndex = selectedIndex = null;

                    $value.blur();
                    closeList();
                }
            }

            const listItemClick = function($option) {
                if (/^http/i.test($option.val())) {
                    window.open($option.val());
                } else {
                    $select.children('option:selected').removeAttr('selected');
                    $option.prop('selected', 'selected');
                    $select.trigger('change', {option: $option});
                    //$(this).data('option').trigger('click');
                }
            }

            $value.on('input', function () {
                let value = $(this).val();
                if (value) {
                    filterList(value);
                } else {
                    clearFilterList(true)
                }

                clearListSelect();
                previousSelectedIndex = selectedIndex = null;
            });

            $value.keydown(function (e) {
                switch (e.which) {
                    case 38:    //up arrow key
                        listUpDown(true);
                        break;
                    case 40:    //bottom arrow key
                        listUpDown();
                        break;
                    case 13:    //enter key
                        listSelect();
                        break;
                }
            });

            // bind onclick
            $list.on('click', 'li', function () {
                listItemClick($(this).data('option'));

                clearListSelect();
                previousSelectedIndex = selectedIndex = null;
            });

            $valueBtn.click(function (e) {
                if (!$html.hasClass('_opened') && !$select.attr('disabled')) {
                    openList();
                }
            });

            $select.hide();

            if ($select.attr('disabled')) {
                $html.addClass('_disabled')
            }

            // подписываемся на изменение атрибутов у селекта
            if (window.MutationObserver) {
                const observer = new MutationObserver(function (records) {
                    const recordTypes = [];

                    records.forEach(record => {
                        if (recordTypes.indexOf(record.type) === -1) {
                            recordTypes.push(record.type);
                        }
                    });

                    if (recordTypes.indexOf('childList') >= 0) {
                        selectize.util.generateCustomList($select, $list);
                        selectize.util.setValue($select, $value);
                    }

                    if ($select.attr('disabled')) {
                        if (!$html.hasClass('_disabled')) {
                            $html.addClass('_disabled');
                            closeList();
                        }
                    } else {
                        $html.removeClass('_disabled');
                    }
                });

                observer.observe($select.get(0), {attributes: true, childList: true});
            }

            $select.change(function () {
                //selectize.util.generateCustomList($select, $list);
                selectize.util.setValue($select, $value);
            });

            $html.insertAfter($select);
            $select.data('selectize_is_init', true);

            $select.closest('form').on('reset', function () {
                setTimeout(function () {
                    selectize.util.generateCustomList($select, $list);
                    selectize.util.setValue($select, $value);
                }, 50);
            });
        });
    }


    // $(window).bind('hashchange', function() {
    //     var hash = location.hash;
    // });
})(require('jquery'));
